var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 45.5H18C7.14 45.5 2.5 40.86 2.5 30V18C2.5 7.14 7.14 2.5 18 2.5H28C28.82 2.5 29.5 3.18 29.5 4C29.5 4.82 28.82 5.5 28 5.5H18C8.78 5.5 5.5 8.78 5.5 18V30C5.5 39.22 8.78 42.5 18 42.5H30C39.22 42.5 42.5 39.22 42.5 30V20C42.5 19.18 43.18 18.5 44 18.5C44.82 18.5 45.5 19.18 45.5 20V30C45.5 40.86 40.86 45.5 30 45.5Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 21.5H36C29.16 21.5 26.5 18.84 26.5 12V3.99998C26.5 3.39998 26.86 2.83998 27.42 2.61998C27.98 2.37998 28.62 2.51998 29.06 2.93998L45.06 18.94C45.48 19.36 45.62 20.02 45.38 20.58C45.14 21.14 44.6 21.5 44 21.5ZM29.5 7.61998V12C29.5 17.16 30.84 18.5 36 18.5H40.38L29.5 7.61998Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27.5H14C13.18 27.5 12.5 26.82 12.5 26C12.5 25.18 13.18 24.5 14 24.5H26C26.82 24.5 27.5 25.18 27.5 26C27.5 26.82 26.82 27.5 26 27.5Z",
    fill: "#455CC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35.5H14C13.18 35.5 12.5 34.82 12.5 34C12.5 33.18 13.18 32.5 14 32.5H22C22.82 32.5 23.5 33.18 23.5 34C23.5 34.82 22.82 35.5 22 35.5Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateCases);
export default __webpack_public_path__ + "static/media/EmptyStateCases.e9d6f5eb.svg";
export { ForwardRef as ReactComponent };